// actions
export const LOAD_SYSTEM_VERSION = 'LOAD_SYSTEM_VERSION'

// mutations
export const SET_SYSTEM_VERSION = 'SET_SYSTEM_VERSION'
